// extracted by mini-css-extract-plugin
module.exports = {"overlay":"confirmation_overlay__18Wxl","dialog":"confirmation_dialog__37mZe"};